import { useId } from 'react';
import { Bounce, toast } from 'react-toastify';

export function useCopyCode(code: string) {
  const uniqueId = useId();
  const copyCode = () => {
    navigator.clipboard.writeText(code);

    if (toast.isActive(uniqueId)) {
      return;
    }

    toast.info('Code copied', {
      toastId: uniqueId,
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'dark',
      transition: Bounce,
    });
  };

  return {
    copyCode,
  };
}
